export default [
  {
    path: '/breast-pump',
    component: () => import('@/views/breastPump/breastPumpList.vue')
  }
];
